import {ref} from "vue";
import {useState} from "#app";

export function useStateClientData() {
    const clientTripData = useState<null | { from: Date, to: Date }>('client-trip-date', () => null);
    const contactNote = useState<string>('contact-note', () => "");

    const setClientTripData = (params: { from: Date, to: Date }) => {
        clientTripData.value = params;
    }
    const setContactNote = (note: string) => {
        contactNote.value = note;
    }
    return {clientTripData, setClientTripData, contactNote, setContactNote}
}
